<template>
  <div
    v-if="show"
    class="alert-info"
    :style="`
      border-left-color: var(${borderColor});
      background-color: ${backgroundColor};
    `"
  >
    <div :class="mode">
      <div class="title">
        <xn-icon :icon="`alert_${type}`" class="icon" />
        <span class="text ml10">{{ title }}</span>
      </div>
      <div class="hints">
        <slot></slot>
      </div>
    </div>
    <CloseOutlined v-if="closeable" class="close-icon" @click="close" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { CloseOutlined } from '@ant-design/icons-vue'

interface Props {
  closeable: boolean
  title: string
  // primary|warning|danger|success|info
  type: string
  // block|inline
  mode: string
}

const props = withDefaults(
  defineProps<Props>(),
  {
    closeable: false,
    title: '提示',
    type: 'primary',
    mode: 'block',
  }
)
const emit = defineEmits(['close'])

const show = ref(true)
const backgrounds = {
  primary: '#E6F4FF',
  warning: '#FFFBE6',
  danger: '#FFF1F0',
  success: '',
  info: '',
}
const borderColor = ref(`--xn-${props.type}`)
if(props.type == 'danger') {
  borderColor.value = '--xn-error'
}
const backgroundColor = ref(backgrounds[props.type] || backgrounds.primary)

const title = ref()
if (props.title) {
  title.value = props.title
} else {
  ['primary', 'success'].includes(props.type) && (props.title = '提示');
  ['warning', 'danger'].includes(props.type) && (props.title = '警告');
  ['info'].includes(props.type) && (props.title = '帮助')
}

const close = () => {
  show.value = false
  emit('close')
}

</script>

<style lang="scss" scoped>
.alert-info {
  position: relative;
  border-left: 4px;
  border-left-style: solid;
  border-radius: 5px;
  .block {
    padding: 16px 12px 12px 20px;
  }
  .inline {
    display: flex;
    align-items: center;
    padding: 14px 12px 12px 20px;
    .title {
      margin-bottom: 0;
      display: flex;
      align-items: center;
    }
    .hints {
      margin-left: 0;
    }
  }
  .title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    margin-bottom: 12px;
  }
  .hints {
    margin-left: 29px;
    :deep {
      > p, div {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0,0,0,0.85);
        &:last-child {
          margin-bottom: 0;
        }
        &:not(:last-child) {
          margin-bottom: 6px;
        }
      }
    }
  }
  .icon {
    width: 20px;
    height: 20px;
  }
  .text {
    display: inline-block;
    vertical-align: top;
  }
  .close-icon {
    position: absolute;
    top: 14px;
    right: 19px;
    font-size: 12px;
    // width: 16px;
    // height: 16px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
    &:hover {
      color: rgba(0, 0, 0, 0.88);
      background-color: rgba(0, 0, 0, 0.06);
      text-decoration: none;
    }
    :deep {
      svg {
        margin: auto
      }
    }
  }
}
</style>

